import "./pwa.ts";
import "./style.css";
import { Game } from "./game/Game.ts";

const canvas = document.getElementById("game");
if (!(canvas instanceof HTMLCanvasElement)) throw new Error("canvas");

const game = new Game(canvas);
game.start();
